import { useEffect } from 'react';

const useDragAndDrop = (
    target: HTMLElement | null,
    onDrop: (event: DragEvent) => void,
    onDragOver?: (e: DragEvent) => void,
    onLeaveDragOver?: (e: DragEvent) => void
) => {
    useEffect(() => {
        const onDropHandler = (event: DragEvent) => {
            event.preventDefault();
            onDrop(event);
        };

        const onDragOverHandler = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            onDragOver?.(event);
        };

        const onLeaveDragOverHandler = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            onLeaveDragOver?.(event);
        };

        if (target) {
            target.addEventListener('dragover', onDragOverHandler);
            target.addEventListener('dragleave', onLeaveDragOverHandler);
            target.addEventListener('drop', onDropHandler);
        }

        return () => {
            target && target.removeEventListener('dragover', onDragOverHandler);
            target && target.removeEventListener('dragleave', onLeaveDragOverHandler);
            target && target.removeEventListener('drop', onDropHandler);
        };
    }, [target, onDrop, onDragOver, onLeaveDragOver]);
};
export { useDragAndDrop };
